import { ComponentPropsWithoutRef, useCallback } from "react";
// components
import IconButton from "components/icon-button";
import ConfirmModal from "components/confirm-modal";
import { ReactComponent as OutlineCrossSmall } from "assets/svg/outline-cross-small.svg";
// hooks
import useToggleModal from "hooks/useToggleModal";
// constants
import messages from "messages";
// styles
import styles from "./styles.module.scss";

type Props = {
  onDelete: () => void;
  isSection?: boolean;
} & ComponentPropsWithoutRef<typeof IconButton>;

const Delete = ({ onDelete, isSection, ...rest }: Props) => {
  const { open, close, show } = useToggleModal(false);

  const handleDelete = useCallback(() => {
    onDelete();
    close();
  }, [close, onDelete]);

  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          open();
        }}
        {...rest}
        className={styles["delete"]}
      >
        <OutlineCrossSmall />
      </IconButton>
      <ConfirmModal
        children={messages.doYouWantToDeleteThisAttachment}
        show={show}
        onCancel={close}
        onConfirm={handleDelete}
        labelConfirm={messages.delete}
        hideCancel={true}
      />
    </>
  );
};

export default Delete;
